module.exports = __webpack_public_path__ + "img/options.159d1985.svg";